import React from 'react'
import UrgencyLabel from 'LuxKit/Label/UrgencyLabel'

interface Props {
  variants: Array<App.MerchandiseOfferVariant>
}

function MerchandiseSaleLabel({ variants }: Props) {
  const isOnSale = variants.some(variant => variant.price !== variant.regularPrice)

  if (!isOnSale) {
    return null
  }

  return <UrgencyLabel variant="critical2">
    Sale
  </UrgencyLabel>
}

export default MerchandiseSaleLabel
